import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-secondary-50">
      <div className="container-page">
        <div className="flex flex-col md:flex-row rounded-2xl overflow-hidden">
          <div className="md:w-1/2 relative min-h-[280px] md:min-h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20reading%20comics%20on%20mobile%20phone%20in%20cozy%20cafe%20setting%2C%20warm%20ambient%20lighting%2C%20soft%20cream%20and%20coral%20tones%2C%20relaxing%20atmosphere%2C%20modern%20lifestyle%2C%20clean%20composition&width=800&height=500&seq=cta-illustration&orientation=landscape"
              alt="随时随地阅读韩漫"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-secondary-50/80 to-transparent"></div>
          </div>

          <div className="md:w-1/2 bg-background-50 flex flex-col items-center justify-center text-center px-8 py-12 md:py-0">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">
              准备好开始你的
              <br />
              <span className="text-primary-500">韩漫之旅</span>了吗？
            </h2>
            <p className="mt-4 text-foreground-500 text-sm max-w-md leading-relaxed">
              海量免费韩漫等你来发现，最新章节极速更新。加入千万读者的行列，享受极致的下拉式阅读体验。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link
                to="/category/lianai"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-8 py-3 rounded-full whitespace-nowrap cursor-pointer transition-all flex items-center gap-2"
              >
                立即开始 <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="text-foreground-600 hover:text-foreground-950 text-sm font-medium px-8 py-3 rounded-full whitespace-nowrap cursor-pointer transition-all flex items-center gap-2 border border-background-200/70"
              >
                了解更多 <i className="ri-information-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}